var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"k-label text-body-2 relative overflow-hidden"},[_c('legend',{staticClass:"caption"},[_vm._v(_vm._s(_vm.label))]),_c('div',{class:{ truncate: _vm.truncate, lines: _vm.lines },style:(_vm.styles)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }